function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#si2rxvz3ca)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.5 14.838c-.88 0-1.705-.167-2.473-.501A6.438 6.438 0 0 1 4.02 12.98a6.438 6.438 0 0 1-1.357-2.007A6.133 6.133 0 0 1 2.162 8.5c0-.88.167-1.705.501-2.474A6.45 6.45 0 0 1 4.02 4.02a6.435 6.435 0 0 1 2.007-1.355A6.126 6.126 0 0 1 8.5 2.162c.88 0 1.705.167 2.474.502A6.446 6.446 0 0 1 12.98 4.02a6.455 6.455 0 0 1 1.356 2.007c.334.77.501 1.594.501 2.474 0 .88-.167 1.705-.501 2.473a6.443 6.443 0 0 1-1.356 2.007 6.448 6.448 0 0 1-2.007 1.357 6.137 6.137 0 0 1-2.474.501zm1.479-3.873a.697.697 0 0 0 .986-.986l-1.76-1.76V5.682a.704.704 0 0 0-1.408 0v3.099l2.182 2.183zM3.5 1.493a.697.697 0 1 1 .986.986L2.479 4.486a.697.697 0 1 1-.986-.986L3.5 1.493zm9.014 0a.697.697 0 0 1 .986 0L15.507 3.5a.697.697 0 1 1-.986.986l-2.007-2.007a.697.697 0 0 1 0-.986z",
  fill: "#fff"
}));

function SvgIconAlarm1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "si2rxvz3ca",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _ref), _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarm1);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxtYXNrIGlkPSJzaTJyeHZ6M2NhIiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiPgogICAgICAgIDxwYXRoIGZpbGw9IiNEOUQ5RDkiIGQ9Ik0wIDBoMTZ2MTZIMHoiLz4KICAgIDwvbWFzaz4KICAgIDxnIG1hc2s9InVybCgjc2kycnh2ejNjYSkiPgogICAgICAgIDxwYXRoIGQ9Ik04LjUgMTQuODM4Yy0uODggMC0xLjcwNS0uMTY3LTIuNDczLS41MDFBNi40MzggNi40MzggMCAwIDEgNC4wMiAxMi45OGE2LjQzOCA2LjQzOCAwIDAgMS0xLjM1Ny0yLjAwN0E2LjEzMyA2LjEzMyAwIDAgMSAyLjE2MiA4LjVjMC0uODguMTY3LTEuNzA1LjUwMS0yLjQ3NEE2LjQ1IDYuNDUgMCAwIDEgNC4wMiA0LjAyYTYuNDM1IDYuNDM1IDAgMCAxIDIuMDA3LTEuMzU1QTYuMTI2IDYuMTI2IDAgMCAxIDguNSAyLjE2MmMuODggMCAxLjcwNS4xNjcgMi40NzQuNTAyQTYuNDQ2IDYuNDQ2IDAgMCAxIDEyLjk4IDQuMDJhNi40NTUgNi40NTUgMCAwIDEgMS4zNTYgMi4wMDdjLjMzNC43Ny41MDEgMS41OTQuNTAxIDIuNDc0IDAgLjg4LS4xNjcgMS43MDUtLjUwMSAyLjQ3M2E2LjQ0MyA2LjQ0MyAwIDAgMS0xLjM1NiAyLjAwNyA2LjQ0OCA2LjQ0OCAwIDAgMS0yLjAwNyAxLjM1NyA2LjEzNyA2LjEzNyAwIDAgMS0yLjQ3NC41MDF6bTEuNDc5LTMuODczYS42OTcuNjk3IDAgMCAwIC45ODYtLjk4NmwtMS43Ni0xLjc2VjUuNjgyYS43MDQuNzA0IDAgMCAwLTEuNDA4IDB2My4wOTlsMi4xODIgMi4xODN6TTMuNSAxLjQ5M2EuNjk3LjY5NyAwIDEgMSAuOTg2Ljk4NkwyLjQ3OSA0LjQ4NmEuNjk3LjY5NyAwIDEgMS0uOTg2LS45ODZMMy41IDEuNDkzem05LjAxNCAwYS42OTcuNjk3IDAgMCAxIC45ODYgMEwxNS41MDcgMy41YS42OTcuNjk3IDAgMSAxLS45ODYuOTg2bC0yLjAwNy0yLjAwN2EuNjk3LjY5NyAwIDAgMSAwLS45ODZ6IiBmaWxsPSIjZmZmIi8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };